// Number formatting for KPI surfaces (locale es-CO). No React.

export function fmtNum(n) {
    return n == null ? '—' : Number(n).toLocaleString('es-CO');
}

export function fmtPct(n) {
    if (n == null) return '—';
    return `${Number(n).toLocaleString('es-CO', { maximumFractionDigits: 1 })}%`;
}

// Money in COP (es-CO). Backend money is DECIMAL(14,2) → number|string. null → '—'.
export function fmtMoney(n) {
    if (n == null) return '—';
    return Number(n).toLocaleString('es-CO', { style: 'currency', currency: 'COP', maximumFractionDigits: 0 });
}
